import { agenticOnboardingSnippetText } from '@gonfalon/dogfood-flags/dogfood-flags';
import { CopyToClipboard } from '@gonfalon/launchpad-experimental/CopyToClipboard';
import { Markdown } from '@gonfalon/markdown/Markdown';
import { Button, Text } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import { trackAgentCommandCopied } from '../../analytics';

import styles from './AgentCommand.module.css';

const DEFAULT_COMMAND =
  'Run `npx skills add launchdarkly/agent-skills --skill onboarding -y` and onboard me to LaunchDarkly';

export const AgentCommand = () => {
  const flagCommand = agenticOnboardingSnippetText();
  const command = flagCommand || DEFAULT_COMMAND;
  return (
    <section className={styles.container} aria-labelledby="agent-command-heading">
      <Text id="agent-command-heading" className={styles.label}>
        Paste this prompt into your AI coding agent's chat
      </Text>
      <div className={styles.promptBox}>
        <Markdown source={command} className={styles.promptText} />
        <CopyToClipboard text={command} onCopy={trackAgentCommandCopied}>
          <Button variant="default" size="small">
            <Icon name="copy-clipboard" size="small" />
            Copy
          </Button>
        </CopyToClipboard>
      </div>
    </section>
  );
};
